import { Collapse } from '@material-ui/core'
import React, { FC, ReactElement, ReactNode, useState } from 'react'
import { ReactState } from '../../Contexts'
import Heading, { HeadingLevel } from '../Heading'
import Icon, { IconName } from '../Icon'
import { IconSize } from '../../../../NonReact/constants/React/Icon/Constants'

type Props = {
    title: string
    children: ReactNode
    className?: string
}

export const CollapseArea: FC<Props> = ({ title, children, className }: Props): ReactElement => {
    const [isOpen, setIsOpen]: ReactState<boolean> = useState<boolean>(false)

    return (
        <div className={`collapse-area ${className} ${isOpen ? 'ca-open' : ''}`}>
            <div className='collapse-area-title' onClick={(): void => setIsOpen(!isOpen)}>
                <Heading level={HeadingLevel.ONE}>{title}</Heading>
                <Icon className='ca-arrow-icon' iconName={IconName.ARROW_DOWN} iconSize={IconSize.LARGE} />
            </div>
            <Collapse in={isOpen} timeout='auto' unmountOnExit>
                {children}
            </Collapse>
        </div>
    )
}
